import {Component,ElementRef,Input, OnInit, Output, ViewChild,} from '@angular/core';
import {AbstractControl, FormBuilder,FormGroup,Validators} from '@angular/forms';
import { Observable } from 'rxjs';
import { GeoService } from 'src/app/services/geo/geo.service';
import { Adresse } from 'src/app/utils/interfaces/new/adresse.interface';
import { Commune } from 'src/app/utils/interfaces/new/commune.interface';
import { FormTemplate } from 'src/app/utils/interfaces/new/form-template.interfac';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-edit-adresse-patient',
  templateUrl: './edit-adresse-patient.fragment.html',
  styleUrls: ['./edit-adresse-patient.fragment.scss'],
})
export class EditAdressePatientComponent implements OnInit {
  @Input('patientId') patientId: string;
  @Output() adresseSecondaireEmitted = new EventEmitter<Adresse>();
  @Output() public closeEmitter = new EventEmitter();

  public cancelButtonText = 'Quitter';
  public updateButtonText = 'Modifier';
  public validateButtonText = 'Ajouter';
  public dismissable = true;
  public formGroup: FormGroup;
  public isError = false;
  public errorMessage = '';
  public formTemplate: FormTemplate = { inputs: [] };

  communesModale$: Observable<Commune[]>;

  constructor(
    public _geoSrv: GeoService,
     private fb: FormBuilder,
    ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      adresse: [''],
      complementAdresse: [''],
      codePostal: ['', Validators.required],
      ville: ['', Validators.required],
      numeroMobile: [''],
      telephone: ['', this.checkPhoneNumber],
      email: ['', [Validators.email, Validators.pattern(/[aA-zZ]+[.][aA-zZ]{2,}/)]],
    });
  }

  public checkPhoneNumber(control: AbstractControl): {[key: string]: boolean } | null {
    const regexPhone = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/gim;
    if (
      control.value !== undefined &&
      control.value !== '' &&
      !regexPhone.test(control.value)
    ) {
      return { patternError: true };
    }
    return null;
  }

  /**
 * lance une recherche par code postal ou par nom de ville avec l'API geoService
 */
  onVilleChange(value: string) {
    const isNumeric = /^[0-9]+$/.test(value); 
    if (isNumeric && value.length >= 5) {
      this.communesModale$ = this._geoSrv.searchCommunesByPostalCode(value);
    } else if (!isNumeric && value.length > 1) {
      this.communesModale$ = this._geoSrv.searchCommunesByName(value);
    } else {
      this.communesModale$ = null;
    }
  }


 /**
 * Permet de séléctionner une ville dans la liste récupérée du géoservice via onVilleChange()
 */
  selectCity(commune: Commune) {
    this.formGroup.get('ville')?.setValue(commune.nom);
    this.formGroup.get('codePostal')?.setValue(commune.codesPostaux[0]);
    this.communesModale$ = null;
  }

  onSubmit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      if (this.formGroup.get('codePostal').value && this.formGroup.get('ville').value) {
        const adresseSecondaire: Adresse = {
          idPatient: this.patientId,
          adresse: this.formGroup.get('adresse').value,
          complementAdresse: this.formGroup.get('complementAdresse').value,
          codePostal: this.formGroup.get('codePostal').value,
          ville: this.formGroup.get('ville').value,
          telephone: this.formGroup.get('telephone').value,
          email: this.formGroup.get('email').value,
          isPrincipale: false,
        };
        this.adresseSecondaireEmitted.emit(adresseSecondaire);
      }
    }
  }

  closeAdresseModal(){
    this.closeEmitter.emit();
  }
}
